import React, { DragEvent, useRef } from "react";
import { FileUploadConfig } from "./types";

interface DropZoneProps {
  isDragOver: boolean;
  isUploading: boolean;
  config: FileUploadConfig;
  onDragOver: (event: DragEvent<HTMLDivElement>) => void;
  onDragLeave: (event: DragEvent<HTMLDivElement>) => void;
  onDrop: (event: DragEvent<HTMLDivElement>) => void;
  onFileSelect: (files: FileList) => void;
}

export const DropZone: React.FC<DropZoneProps> = ({
  isDragOver,
  isUploading,
  config,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileSelect
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      onFileSelect(files);
    }
  };

  return (
    <div style={{ marginBottom: "20px" }}>
      <div
        style={{
          border: isDragOver ? "2px solid #007bff" : "2px dashed #007bff",
          borderRadius: "8px",
          padding: "40px 20px",
          textAlign: "center",
          backgroundColor: isDragOver ? "#e3f2fd" : "#f8f9ff",
          cursor: "pointer",
          transition: "all 0.3s ease",
          transform: isDragOver ? "scale(1.02)" : "scale(1)"
        }}
        onClick={handleClick}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <div
          style={{
            fontSize: "48px",
            color: "#007bff",
            marginBottom: "10px",
            transform: isDragOver ? "scale(1.1)" : "scale(1)",
            transition: "transform 0.2s ease"
          }}
        >
          {isDragOver ? "📂" : "📁"}
        </div>
        <div style={{ fontSize: "16px", color: "#333", marginBottom: "5px" }}>
          {isDragOver
            ? "파일을 여기에 놓으세요"
            : "파일을 선택하거나 여기에 드래그하세요"}
        </div>
        <div style={{ fontSize: "14px", color: "#666" }}>
          여러 파일을 동시에 선택할 수 있습니다
        </div>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        onChange={handleFileChange}
        style={{ display: "none" }}
        disabled={isUploading}
        accept={config.acceptedFileTypes}
      />
    </div>
  );
};
